import { Accordion, AccordionSummary, styled } from '@mui/material';
import { CoreTypography } from '@youscience/core';

export const sxStyles = {
  accordionDetails: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: '1.5rem',
    padding: '1.5rem 0 2.5rem',
  },
};

export const StyledAccordion = styled(Accordion)(({ theme }) => ({
  boxShadow: 'none',
  // TODO add colors to library
  backgroundColor: '#F9F9F9',
  marginTop: '0 !important',
  borderBottom: `1px solid ${theme.palette.grey['300']}`,

  '&:before': {
    height: 0,
  },
}));

export const StyledAccordionSummary = styled(AccordionSummary)(({ theme }) => ({
  padding: 0,
  position: 'relative',

  '.MuiAccordionSummary-content': {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'start',
    margin: '1rem 0',
  },

  '.MuiAccordionSummary-content.Mui-expanded': {
    margin: '1rem 0',
  },

  '.MuiAccordionSummary-expandIconWrapper': {
    position: 'absolute',
    left: 0,
    top: '4rem',
  },

  '.MuiAccordionSummary-expandIconWrapper.Mui-expanded': {
    position: 'absolute',
    left: 0,
    top: '4rem',
    transform: 'rotate(90deg)',
  },

  [theme.breakpoints.up('md')]: {
    '.MuiAccordionSummary-content': {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      margin: '1rem 0',
    },
  },
}));

export const StyledActionsWrap = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  marginTop: '2rem',

  [theme.breakpoints.down('md')]: {
    marginLeft: '1rem',
    marginTop: 0,
  },
}));

export const StyledAreaTitle = styled(CoreTypography)(({ theme }) => ({
  color: theme.palette.primary.main,
  marginTop: '2rem',
  marginLeft: '1.5rem',

  [theme.breakpoints.down('md')]: {
    fontSize: '1.25rem',
    marginLeft: '1rem',
  },
}));

export const StyledCipCode = styled(CoreTypography)(({ theme }) => ({
  margin: '0 1rem 0 0.5rem',
  color: theme.palette.grey['600'],
  fontWeight: 400,
  minWidth: '98px',

  [theme.breakpoints.down('md')]: {
    fontSize: '1.25rem',
    minWidth: 'auto',
    margin: '0 0.25rem',
  },
}));

export const StyledActionIcon = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  padding: '0.75rem',

  '& > svg:first-of-type': {
    fill: theme.palette.primary.main,
  },

  '&:hover': {
    // TODO add color to library
    backgroundColor: '#EBF6F7',
    cursor: 'pointer',
  },
}));
